import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import ImageType from '../../../shared/enums/image-type.enums';
import ViewportType from '../../../shared/enums/viewport-type.enums';

@Component({
  selector: 'hdi-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
  host: {
    id: crypto.randomUUID().toString(),
  },
})
export class ImageComponent implements OnChanges {
  @Input() viewport: ViewportType = ViewportType.desktop;
  @Input() src: string = '';
  @Input() alt?: string = '';
  @Input() title?: string = '';
  @Input() lazy: boolean = true;
  @Input() width: string = '100%';
  @Input() height: string = 'auto';
  @Input() border: boolean = false;
  @Input() imagePosition: string = 'center';
  @Input() mobileSrc?: string;

  resolvedSrc: string | { src: string; media: string }[] = '';

  constructor(private el: ElementRef) {}

  protected readonly ImageType = ImageType;
  protected readonly Array = Array;

  onImageLoad(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    if (imgElement) {
      imgElement.classList.add('loaded');
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']?.currentValue || changes['mobileSrc']?.currentValue) {
      this.resolvedSrc = this.parseSrc(
        changes['src']?.currentValue || changes['mobileSrc']?.currentValue
      );
    }
  }

  /**
   * Parses the input `src` to determine if it’s a JSON array or a single string.
   * Handles HTML-encoded input gracefully.
   */
  private parseSrc(src: string): string | { src: string; media: string }[] {
    if (!src) {
      console.warn('ImageComponent: src is empty or undefined.');
      return '';
    }

    try {
      const parsed = JSON.parse(src);
      if (Array.isArray(parsed)) return parsed;
      console.warn('ImageComponent: src is valid JSON but not an array:', src);
    } catch (error) {
      if (typeof src === 'string') {
        return src;
      }
      console.warn('ImageComponent: Failed to parse src as JSON:', error);
    }

    return src;
  }
}
